export default "__VITE_ASSET__X1Iv249___"